import React, { FC } from 'react';
import { LuCheck } from 'react-icons/lu';
import SectionTitle from './SectionTitle';
import { skillGroups } from '../data/profile';

const points = [
  'Apps Android nativos com Kotlin e Jetpack Compose',
  'Sites e sistemas web com React e Next.js',
  'Autenticação, banco de dados e hospedagem com Firebase',
  'Foco em performance, simplicidade e boa experiência de uso',
];

const About: FC = () => (
  <section id="sobre" className="section">
    <div className="container">
      <SectionTitle
        eyebrow="Sobre mim"
        title="Código limpo, produtos úteis"
        subtitle="Desenvolvedor apaixonado por tecnologia, criando soluções que facilitam a vida das pessoas."
      />

      <div className="about">
        <div className="about__text reveal">
          <p>
            Sou <strong>Bruno Oliveira</strong>, desenvolvedor Android e web e criador da marca <strong>Crânio da Tecnologia</strong>.
            Desenvolvo aplicativos, jogos, sites e sistemas completos, cuidando de tudo: interface, lógica, banco de dados em nuvem e
            publicação.
          </p>
          <p>
            Também estudo Análise e Desenvolvimento de Sistemas, o que me ajuda a unir prática do dia a dia com boa base técnica.
          </p>
          <ul className="checks">
            {points.map((p) => (
              <li key={p}>
                <span className="checks__icon"><LuCheck size={14} /></span>
                {p}
              </li>
            ))}
          </ul>
        </div>

        <div className="skills reveal">
          <h3>Tecnologias</h3>
          {skillGroups.map((g) => (
            <div key={g.title} className="skills__group">
              <h4>{g.title}</h4>
              <ul>
                {g.items.map((i) => (
                  <li key={i} className="chip">{i}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default About;
